import React from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from '@/reportWebVitals';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { MotionConfig } from 'framer-motion';
import { pages } from "@/Environment";
import UploadStatement from "@/pages/upload_statement/index";
import ViewGradeWrapper from "@/pages/view_grade/index";
import PageNotFound from '@/pages/page_not_found';
import EmailVerification from '@/pages/auth/verify';
import PrivacyPolicy from '@/pages/privacy';
import SubProcessorsPage from '@/pages/subprocessors';
import TrustPage from '@/pages/trust';
import DesignDemo from '@/pages/design-demo';
import Header from '@/components/header';
import Supporters from '@/components/supporters';
import LandingPage from "@/pages/landing";
import { AuthProvider } from '@/contexts/AuthContext';
import ErrorBoundary from '@/components/ErrorBoundary';
import '@/styles/index.css';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      {/* Honour the reduced-motion setting: movement off, fades kept */}
      <MotionConfig reducedMotion="user">
      <Router>
        <AuthProvider>
          <div className="flex flex-col min-h-screen w-full">
            <Header />
          
          <div className="flex-grow pt-20">
            <Routes>
              <Route exact path="/" element={<LandingPage />} />
              {/* Component showcase, local development only */}
              {import.meta.env.DEV && <Route path="/design" element={<DesignDemo />} />}
              <Route path={pages.UPLOAD} element={<UploadStatement />} />
              <Route path={pages.REVIEW} element={<ViewGradeWrapper />} />
              <Route path="/auth/verify" element={<EmailVerification />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/sub-processors" element={<SubProcessorsPage />} />
              <Route path="/trust" element={<TrustPage />} />
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </div>
        
        <Supporters />

        <footer className="mt-12 border-t border-[rgba(31,76,84,0.08)] bg-white py-6">
          <div className="mx-auto flex max-w-6xl flex-col items-center gap-3 px-6 text-sm text-[var(--text-secondary)]">
            <div className="flex gap-4">
              <a href="/privacy" className="transition hover:text-[var(--accent)]">
                Privacy Policy
              </a>
              <span>·</span>
              <a href="/sub-processors" className="transition hover:text-[var(--accent)]">
                Sub-processors
              </a>
              <span>·</span>
              <a href="/trust" className="transition hover:text-[var(--accent)]">
                Trust & Security
              </a>
            </div>
            <p>© {new Date().getFullYear()} Anti-Slavery Intelligence. All rights reserved.</p>
          </div>
        </footer>
          </div>
        </AuthProvider>
      </Router>
      </MotionConfig>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
